export class ErzeugungsanlageFilter {
    constructor(
        public westnetzId?: string,
        public stadtwerkeId?: string,
        public installierteLeistungMin?: number,
        public installierteLeistungMax?: number,
        public anlagentype?: string,
        public anlagentypnummer?: string,
        public ortsnamen?: string,
        public stationsnamen?: string,
        public netzzuordnungId?: string,
        public leitstellenRegion?: string | string[],
        public netzbetreiberName?: string,
        public netzbetreiberTeilgebiet?: string,
        public status?: boolean,
    ) {
    }
}

